import React, {useEffect, useState} from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import getServices from '../../Services/get-service';
import Loading from '../SelectValue/Loading';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
//   const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     '&:nth-of-type(odd)': {
//       backgroundColor: theme.palette.action.hover,
//     },
//     // hide last border
//     '&:last-child td, &:last-child th': {
//       border: 0,
//     },
//   }));
  



export default function NotificationTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [propList, setPropList] = useState([])
  const [totalItems, setTotalItems] = useState(0)
  const [loading, setLoading] = useState(false)
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  


useEffect(() =>{
  setLoading(true)
    getServices.getAdminNotifications(page, rowsPerPage).then(
      (response) => {
        setLoading(false)
      if(response.data.status === "2000"){
        setPropList(response.data.data.notifications || [])
        setTotalItems(response.data.data.pagination?.totalItems || 0)
      }else{
      //  swal(response.data.description)
      //  toast('Session Expired', {
      //   onClose: () => {
      //       window.location.href = '/'
      //   },
      //   autoClose: 5000
      // })
      }
    },
    (error) => {
        setLoading(false)
        // toast('Session Expired', {
        //     onClose: () => {
        //       window.location.href = '/'
        //     },
        //     autoClose: 5000
        //   })
    }
    )
},[page, rowsPerPage])


  return (
    <>
    <Loading open={loading}/>
    <p className=' text-[24px] font-[400]'>Notification Table</p>
   
    <Paper className=' mt-6' sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead style={{backgroundColor:'red', color: 'white',}}>
            <TableRow >
            <StyledTableCell>Title</StyledTableCell>
            <StyledTableCell align="center">content</StyledTableCell>
            <StyledTableCell align="center">Target</StyledTableCell>
            <StyledTableCell align="center">Status</StyledTableCell>
            <StyledTableCell align="right">Date added</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {propList
              .map((row, index) => (
            <TableRow
              key={row.id || index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.header}
              </TableCell>
              <TableCell align="center">{row.content}</TableCell>
              <TableCell align="center">{row.targetGroup || 'All'}</TableCell>
              <TableCell align="center">
                <span className={row.readStatus ? 'text-primary-color' : 'text-[#44474E]'}>
                  {row.readStatus ? 'Read' : 'Unread'}
                </span>
              </TableCell>
              <TableCell align="right" className=' text-primary-color '>{row.createdDate === null ? 'No date': row.createdDate.slice(0,10)}</TableCell>
            </TableRow>
          ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalItems}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <div className=' my-3'>
          { propList.length === 0 && <p className=' text-red-600  text-center'>No Notification found</p>}
      </div>
    </Paper>
    </>
  );
}
